var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.23779,
    cy: 6,
    r: 6,
    fill: "#EE9023"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 11.6435C14.1125 11.3185 15.1094 10.6279 15.8656 9.57166C16.6219 8.51541 17 7.32478 17 5.99978C17 4.67478 16.6219 3.48416 15.8656 2.42791C15.1094 1.37166 14.1125 0.681031 12.875 0.356031C12.7 0.306031 12.55 0.334156 12.425 0.440406C12.3 0.546656 12.2375 0.693531 12.2375 0.881031C12.2375 0.993531 12.2781 1.09978 12.3594 1.19978C12.4406 1.29978 12.5375 1.36853 12.65 1.40603C13.625 1.69353 14.4062 2.26541 14.9938 3.12166C15.5813 3.97791 15.875 4.93728 15.875 5.99978C15.875 7.06228 15.5813 8.02166 14.9938 8.87791C14.4062 9.73416 13.625 10.306 12.65 10.5935C12.5375 10.631 12.4406 10.6967 12.3594 10.7904C12.2781 10.8842 12.2375 10.9935 12.2375 11.1185C12.2375 11.306 12.3 11.4529 12.425 11.5592C12.55 11.6654 12.7 11.6935 12.875 11.6435Z",
    fill: "#EE9023"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.29f39e06b1602237ea25252b0b534962.svg";
export { ForwardRef as ReactComponent };